import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import useAuthentication from "./useAuthentication";

// Redirect the user to "app page" if its authenticated and try to reach "/authentication" routes.
export default function useRedirectIfAuthenticated() {
  const { currentUser } = useAuthentication();
  const history = useHistory();

  useEffect(() => {
    if (currentUser) history.push("/app");
  });
}
